import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createChartEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackChartOpen = (source: PosthogTrackingSource, type?: string) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.CHART_OPEN,
      properties: { source, type },
    });

  return { trackChartOpen };
};
